<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div class="wrap clientindex">
        <div class="monitor-header">
          <h1>Мониторинг исполнения стандарта организации деятельности органов службы занятости в субъектах
            Российской Федерации</h1>
          <div class="download-menu">
            <v-dialog
                v-model="checkListExportDialog"
                max-width="650px"
                persistent>
              <template v-slot:activator="{ on }">
                <div class="download-menu-icon" v-on="on">
                  <svg
                      fill="none"
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M8 17V15H16V17H8ZM16 10L12 14L8 10H10.5V7H13.5V10H16ZM5 3H19C20.11 3 21 3.9 21 5V19C21 20.11 20.11 21 19 21H5C3.9 21 3 20.11 3 19V5C3 3.9 3.9 3 5 3ZM5 5V19H19V5H5Z"
                        fill="#0033A0"
                    />
                  </svg>
                </div>
              </template>

              <OrgMonitorCheckListExportDialog
                  @close="checkListExportDialog=false; exportDialogKey++"
                  :region="regionAndDepartmentInfo.region?.name"
                  :user-department="regionAndDepartmentInfo?.department"
                  :key="exportDialogKey"/>
            </v-dialog>
          </div>
        </div>
        <div class="monitor-filter  ">
          <div class="d-flex flex-column flex-grow-1">
            <RegionAndDepartmentPicker
              class="mb-1"
              v-if="tabSelected !== 2"
              v-model="regionAndDepartmentInfo"
              nullable-department="true"
              :regions="regions"
              :loading="loading"
            ></RegionAndDepartmentPicker>
            <ModernizationWave :count="regionAndDepartmentInfo?.region?.modernizationWave" />
          </div>
          <div class="passport-buttons">
            <v-dialog
                v-model="dialog"
                max-width="800px"
                persistent>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn outlined>
                    документы
                  </v-btn>
                </div>
              </template>
              <PassportInfoDocsDialog
                  :region="regionAndDepartmentInfo.region"
                  :departments="regionAndDepartmentInfo.region?.departments"
                  section="Мониторинг стандарта организации деятельности"
                  @close="dialog=false; dialogKey++" :key="dialogKey"
                  @edit="dialog=false; dialogUpload=true;"/>
            </v-dialog>
            <v-btn outlined @click="$router.push('/orgmonitor/archive')"
                   v-if="$user.role==='ROLE_ADMIN' || $user.role==='ROLE_VNII'">
              архив<br>документов
            </v-btn>
            <v-dialog
                v-model="dialogUpload"
                max-width="800px"
                persistent>
              <PassportInfoDocsUploadDialog
                  :region="regionAndDepartmentInfo.region"
                  :departments="regionAndDepartmentInfo.region?.departments"
                  section="Мониторинг стандарта организации деятельности"
                  :categories="passportConfig?.documentCategories"
                  @close="dialogUpload=false; dialogKey++"
                  :key="dialogKey"
              />
            </v-dialog>
          </div>
        </div>

        <div class="block">
          <v-select
              style="width: 400px"
              :items="periods"
              v-model="period"
              label="Период мониторинга"
              item-text="name"
              return-object
              dense
          >
            <template v-slot:selection="{ item }">
              <div>
                <div>
                  {{ item.name }}
                </div>
                <div :class="periodStatusClass(item.status)">
                  {{ periodStatusText(item.status) }}
                </div>
              </div>
            </template>
            <template v-slot:item="{ item }">
              <div>
                <div>
                  {{ item.name }}
                </div>
                <div :class="periodStatusClass(item.status)">
                  {{ periodStatusText(item.status) }}
                </div>
              </div>
            </template>
          </v-select>
        </div>

        <DashboardRating
            v-if="period"
            :region-code="regionAndDepartmentInfo.region?.code"
            :period-code="period.code"
        />

        <v-tabs v-if="period && !loading" v-model="tabSelected">
          <v-tab>
            Сведения для расчёта показателей
          </v-tab>
          <v-tab>
            Отчёты
          </v-tab>
          <v-tab v-if="[
              ROLES.ROLE_ADMIN,
              ROLES.ROLE_VNII,
              ROLES.ROLE_MINTRUD,
              ROLES.ROLE_REGIONAL_AGENCY,
              ROLES.ROLE_CZN_MANAGER,
              ].includes($user.role)">
            Рейтинги
          </v-tab>

          <v-tab-item>
            <OrgMonitorCheckList
                v-if="regionAndDepartmentInfo.department"
                :region-and-department-info="regionAndDepartmentInfo"
                :period="period"
                :config="config"
                :key="checkListKey"
            ></OrgMonitorCheckList>
            <OrgMonitorCheckListBase
                v-else
                :region-and-department-info="regionAndDepartmentInfo"
                :period="period"
                :config="config"
                :key="checkListKey + '_base'"
            ></OrgMonitorCheckListBase>
          </v-tab-item>

          <v-tab-item>
            <OrgMonitorReports
                :region-and-department-info="regionAndDepartmentInfo"
                :period="period"
                :key="reportsKey"
            ></OrgMonitorReports>
          </v-tab-item>

          <v-tab-item v-if="[
              ROLES.ROLE_ADMIN,
              ROLES.ROLE_VNII,
              ROLES.ROLE_MINTRUD,
              ROLES.ROLE_REGIONAL_AGENCY,
              ROLES.ROLE_CZN_MANAGER,
              ].includes($user.role)">
            <OrgMonitorRating
                :region-and-department-info="regionAndDepartmentInfo"
                :only-current-region="[ROLES.ROLE_REGIONAL_AGENCY, ROLES.ROLE_CZN_MANAGER].includes($user.role)"
                :period="period"
                :key="ratingKey"
            ></OrgMonitorRating>
          </v-tab-item>
        </v-tabs>
      </div>
    </transition>
    <LoaderDialog :show="loading" msg="Загрузка..."></LoaderDialog>
  </div>
</template>

<script>

import OrgMonitorReports from "@/components/orgmonitor/OrgMonitorReports";
import OrgMonitorRating from "@/components/orgmonitor/OrgMonitorRatings";
import OrgMonitorCheckList from "@/components/orgmonitor/OrgMonitorCheckList";
import OrgMonitorCheckListExportDialog from "@/components/dialogs/OrgMonitorCheckListExportDialog";
import PassportInfoDocsDialog from "@/components/dialogs/PassportInfoDocsDialog";
import PassportInfoDocsUploadDialog from "@/components/dialogs/PassportInfoDocsUploadDialog";
import RegionAndDepartmentPicker from "@/components/RegionAndDepartmentPicker";
import OrgMonitorCheckListBase from "@/components/orgmonitor/OrgMonitorCheckListBase";
import {setDepartmentsByRegion} from "@/modules/OrgMonitor";
import { ROLES } from '@/modules/constants';
import ModernizationWave from "@/components/elements/ModernizationWave";
import DashboardRating from "./DashboardRating.vue";
import {periodStatusClass, periodStatusText} from "@/modules/periods";
import {getPeriodsByDomain} from "@/modules/api.periods";
import {getSnapshotDepartmentsByRegion} from "../../main";
import {getActiveDomainConfigs, getSnapshotDomainConfigs} from "../../modules/api.configs";
import LoaderDialog from "../elements/LoaderDialog.vue";

export default {
  name: 'OrgMonitorComponent',
  components: {
    LoaderDialog,
    RegionAndDepartmentPicker,
    PassportInfoDocsUploadDialog,
    PassportInfoDocsDialog,
    OrgMonitorReports,
    OrgMonitorRating,
    OrgMonitorCheckList,
    OrgMonitorCheckListBase,
    OrgMonitorCheckListExportDialog,
    ModernizationWave,
    DashboardRating
  },
  data: () => ({
    ROLES,
    domain: 'org_monitor',
    regionAndDepartmentInfo: {
      region: null,
      department: null
    },
    periods: [],
    period: null,
    config: null,
    tabSelected: 0,
    reportsKey: 0,
    ratingKey: 0,
    checkListKey: 0,
    checkListExportDialog: false,
    exportDialogKey: 0,
    dialog: false,
    dialogUpload: false,
    dialogKey: 0,
    passportConfig: {},
    regions: null,
    loading: false,
  }),
  methods: {
    periodStatusClass,
    periodStatusText,
    async loadPeriods() {
      const result = (await getPeriodsByDomain(this.domain)).payload
      if (result && result.length) {
        this.periods = result
        this.period = result[0]
      }
    },
    async loadRegions() {
      const activeRegions = this.$cznDepartmentsByRegionList;
      const snapshotRegions = this.period?.status === 'CLOSED'
          ? await getSnapshotDepartmentsByRegion(this.domain, this.period)
          : null;

      this.regions = snapshotRegions ?? activeRegions;
      setDepartmentsByRegion(this.regions);
    },
    async loadConfig() {
      const activeConfig = (await getActiveDomainConfigs(this.domain)).payload?.[0]?.content;
      const snapshotConfig = this.period?.status === 'CLOSED'
          ? (await getSnapshotDomainConfigs(this.domain, this.period.code))?.payload?.content
          : null;

      this.config = snapshotConfig ?? activeConfig;
    },
    async loadPassportConfig() {
      let req = await this.$getApi("/passport/getActiveConfig");
      if (req.ok) {
        this.passportConfig = req.payload;
        this.passportConfig.documentCategories = JSON.parse(this.passportConfig.documentCategoriesJson);
      } else {
        this.errorText =
            "Ошибка подключения к серверу или обработки запроса: " + req.error;
      }
    },
  },
  watch: {
    period: {
      async handler() {
        this.loading = true;
        await this.loadConfig();
        await this.loadRegions();
        this.loading = false;
      },
    },
  },
  async beforeMount() {
    await this.loadPassportConfig()
    await this.loadPeriods()
    const queryPeriod = this.$route.query.period
    if (queryPeriod) {
      this.period = queryPeriod
    }
  }
}
</script>

<style lang="scss">
@import "../../styles/main";

.top-progress {
  margin-bottom: 30px;
  display: flex;
  align-items: center;

  > div > div {
    display: flex;
    flex-direction: column;
    height: 280px;
    border-radius: 20px;
    padding: 30px;

    div {
      font-weight: 600;
      font-size: 64px;
      line-height: 100%;
    }

    p {
      margin-top: auto;
      margin-bottom: 0;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 140%;
      color: #1C1C1F;

    }
  }

}

.v-input--radio-group.v-input--radio-group--row {
  margin: 0;
}

.date-switch {
  margin-bottom: 60px;
  display: flex;
  justify-content: center;
  color: #0033A0;
}

.clientindex {
  div.blue {
    background: #E1F0FA !important;
    color: #2F80ED !important;
  }

  div.green {
    background: #E2F5EA !important;
    color: #27AE60 !important;
  }

  div.yellow {
    background: #FCF4DB !important;
    color: #F2994A !important;
  }

  div.darkblue {
    background: #E5EBF5 !important;
    color: #0033A0 !important;
  }

  .badge {
    height: 30px;
    margin-left: 4px;
    margin-right: 0;
    font-size: 13px;
    font-weight: 700;
  }

  .v-slide-group__content.v-tabs-bar__content {
    justify-content: stretch !important;

    .v-tab {
      flex: 1 1 50%;
      max-width: initial;
    }
  }

  .v-window-item {
    padding-top: 0px;
  }

  .v-expansion-panel .level2 {
    padding-top: 5px;

    .v-expansion-panel-content {
      padding-left: 44px;
    }
  }

  .v-expansion-panel-content p {
    font-weight: 500;
    font-size: 14px;
    line-height: 160%;
    color: #1C1C1F;
    margin: 10px 0;
  }

  .list .list-item-wrap .list-item-name {
    max-width: none;

    .toggleSwitch {
      align-self: center;
    }
  }

  .list .list-item-wrap .list-item {
    justify-content: flex-start;

    .v-progress-circular {
      margin-left: 0;

      .v-progress-circular__info {
        font-size: 16px;
        font-weight: 600;
        display: block;

        .text-caption {
          font-size: 10px !important;
          vertical-align: baseline;
          display: inline;
        }
      }
    }
  }

  .list-item-wrap .list-item-wrap {
    border: none;
    padding-bottom: 5px;
  }
}

.graph-wrap {
  background: #F3F3F3;
  border-radius: 20px;
  padding: 30px 30px 0 30px;

  h3 {
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 160%;
    color: #1C1C1F;
    text-align: center;
    margin-bottom: 10px;
  }

  .graph-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 30px;
    margin-bottom: 10px;

    div:first-child {
      font-size: 36px;
      line-height: 30px;

      span {
        font-size: 12px;
        vertical-align: text-top;
      }
    }

    div:last-child {
      font-weight: 600;
      font-size: 16px;
      color: #1C1C1F;
    }

    &.text-blue {
      color: #2F80ED;

      div:last-child span {
        color: #2F80ED;
      }
    }

    &.text-orange {
      color: #F2994A;

      div:last-child span {
        color: #F2994A;
      }
    }

  }

  &.checklist-wrap {
    padding: 20px;
    display: flex;
    gap: 30px;
    background: #F3F3F3;
    border-radius: 20px;
    min-height: 130px;

    > div:first-child {
      width: 140px;

      div {
        color: #2F80ED;
        font-size: 36px;
        line-height: 30px;
        font-weight: 600;

        span {
          vertical-align: text-top;
          font-size: 12px;
          color: #2F80ED;
        }
      }
    }

    .checklist > div {
      display: flex;
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 14px;
      line-height: 160%;
      gap: 10px;

      span {
        width: 14px;
      }

      svg {
        margin-top: 4px;
      }

      &.checked {
        color: #0033A0;
      }
    }

    .v-progress-circular__info {
      font-size: 16px;
      display: block;
      font-weight: 600;

      .text-caption {
        font-size: 7px !important;
        vertical-align: baseline;
      }
    }
  }
}

.line-wrap {
  border: 1px solid #E8E8E9;
  border-radius: 4px;
}

.v-tabs {
  .v-tabs-bar {
    margin: 0 0 50px 0;
  }
}

.monitor-header {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  gap: 20px;
  position: relative;

  h1 {
    flex: 1 1 100%;
  }

  .download-menu {
    top: 10px;
    position: relative;
    padding-left: 0;
    margin-top: 0;
    flex: 0 0 56px;
  }
}
</style>
